export default __webpack_public_path__ + "static/media/step2.b99b2a48.svg";